import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  badge?: string;
}

export default function ComicCard({ comic, badge }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.coverUrl}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画网免费在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {badge && (
          <span className="absolute top-3 left-3 px-3 py-1 text-xs font-medium rounded-full bg-foreground-900/80 text-background-50">
            {badge}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          <span className={`text-xs font-medium px-2 py-0.5 rounded ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4 text-center">
        <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          更新至 {comic.chapters.length} 话
        </p>
        <div className="flex items-center justify-center gap-2 mt-2">
          <span className="flex items-center gap-1 text-xs text-accent-600">
            <i className="ri-star-fill text-xs"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-400">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views} 次阅读
          </span>
        </div>
      </div>
    </Link>
  );
}